<template>
  <div class="component-modal" id="modal">
    <form class="form" v-on:submit.prevent>
      <legend>{{ $t("modal.spot_programming.import_data.title") }}</legend>
      <i class="material-icons icon" @click.stop.prevent="closeModal">close</i>

      <div class="component-modal__row component-modal__row__multiselect">
        <label for="type_file">{{$t("modal.spot_programming.import_data.type_files")}} <small>*</small></label>
        <Multiselect
          v-model="fileType"
          :searchable="false"
          :canDeselect="false"
          :canClear="false"
          :options="[
            { value: 'INE', label: `INE` },
            { value: 'RTC', label: `RTC` },
          ]" />
      </div>

      <div class="component-modal__row" v-if="fileType == 'RTC'">
        <label for="program">{{$t("modal.spot_programming.spot.generate_block.station")}}
          <small v-if="submitted && stations.length == 0" class="pill-required">* {{ $t("modal.common.required") }}</small>
          <small v-else>*</small>
        </label>
        <div class="component-modal__row">
          <div class="component-modal-checkbox">
            <label>
              <input type="checkbox" v-model="allStationsActive" @change="allStationsActive ? stations = listStations.map(s => Number(s.id)) : stations = []"> 
              {{$t("modal.spot_programming.spot.generate_block.all_station")}} 
            </label>
          </div>
          <template v-for="station in listStations" :key="station.id">
            <div class="component-modal-checkbox">
              <label :for="station.id">
                <input type="checkbox" :name="station.id" :id="station.id" :value="station.id" v-model="stations" :disabled="allStationsActive">
                {{ station.name }}
              </label>
            </div>
          </template>
        </div>
      </div>

      <label for="images" class="drop-container" v-if="!file" style="margin-top: 12px;">
        {{ fileType == 'INE' ? $t("modal.spot_programming.import_data.drop_INE") : $t("modal.spot_programming.import_data.drop_RTC") }}
        <input type="file" id="images" accept=".xls,.xlsx,.zip" @change="selectFile">
      </label>

      <div class="drop-container selected" v-else>
        <div style="max-width: 352px">
          <i class="material-icons">description</i>
          <span class="fileName">{{ file.name }}</span>
        </div>
        
        <i class="material-icons remove" @click="file = null">cancel</i>
      </div>

      <button type="button" :class="{'disabled': !file}" :disabled="!file" @click.stop.prevent="saveAndClose">
        {{ $t("modal.apply") }}
      </button>
      <button type="button" class="button-cancel" @click.stop.prevent="closeModal">
        {{ $t("modal.cancel") }}
      </button>

      <div class="alert-info gray" v-if="process">
        {{ $t("modal.spot_programming.import_data.process") }}
      </div> 
    </form>
  </div>
</template>

<script>
import { onMounted, ref, computed } from "@vue/runtime-core";
import { useStore } from "vuex";
import Multiselect from '@vueform/multiselect';

export default {
  components: {
    Multiselect
  },
  setup() {
    const store = useStore();
    const file = ref();
    const process = ref(false);
    const submitted = ref(false);
    const fileType = ref('INE');
    const stations = ref([]);
    const allStationsActive = ref(true);
    const listStations = computed(() => store.getters.station_stations({name: ''}));
    
    onMounted(async () => {
      await store.dispatch('station_getAll');
      stations.value = listStations.value.map(station => Number(station.id));
    })

    function selectFile(e) {
      const files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      if (!files[0].name.endsWith('.xls') && !files[0].name.endsWith('.xlsx') && !files[0].name.endsWith(".zip")) return;
      if (files[0].size >= 30000000) return;
      file.value = files[0];
    }

    async function closeModal() {
      await store.dispatch("modal_setActive");
    }

    async function saveAndClose() {
      submitted.value = true;
      if (stations.value.length == 0) return;

      process.value = true;
      const formData = new FormData();
      
      store.dispatch('loading_setActive', true);
      try {
        if (fileType.value == 'INE') {
          formData.append('fileStream', file.value);
          await store.dispatch('importer_importINE', formData);
        } else if (fileType.value == 'RTC') {
          formData.append('file', file.value);
          formData.append('stations', stations.value);
          await store.dispatch('importer_importRTC', formData);
        }
        this.closeModal();
      } catch (error) {
        console.log(error);
      } finally {
        process.value = false;
        store.dispatch('loading_setActive', false);
      }
    }

    return {
      file,
      fileType,
      stations,
      listStations,
      allStationsActive,
      submitted,
      selectFile,
      saveAndClose,
      closeModal,
      process
    };
  },
};
</script>
<style lang="scss">
  .drop-container {
    position: relative;
    display: flex;
    gap: 12px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 20px;
    border-radius: 4px;
    border: 1px dashed #555;
    cursor: pointer;
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 20px;

    input {
      display: none;
    }

    &.selected {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      border: 1px solid;

      div {
        display: flex;
        align-items: center;
        gap: 8px;
        font-weight: lighter;
        font-size: 14px;

        i {
          font-size: 20px;
          color: #555;
        }
      }

      .remove {
        color: tomato;
      }
    }
  }

  .alert-info {
    display: inline-block;
    background: #3f51b5;
    padding: 16px;
    border-radius: 4px;
    margin: 16px 0;

    &.gray {
      background: #555;
      float: right;
    }
  }
</style>
